"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MeetingStatuses;
(function (MeetingStatuses) {
    MeetingStatuses[MeetingStatuses["Finalized"] = 1] = "Finalized";
    MeetingStatuses[MeetingStatuses["Working"] = 2] = "Working";
    MeetingStatuses[MeetingStatuses["Requested"] = 3] = "Requested";
})(MeetingStatuses || (MeetingStatuses = {}));
exports.default = MeetingStatuses;
